export const team = [
  "Основные фразы",
  "Путешествия и транспорт",
  "Здоровье",
  "Отель",
  "Покупки и сервис",
  "Ресторан",
];

export const fraz_1 = [
  { ru: "Добро пожаловать!", port: "Bem-vindo! / Bem-vinda! / Bem-vindos!" },
  { ru: "Доброе утро", port: "Bom dia." },
  { ru: "Доброй ночи", port: "Boa noite." },
  { ru: "Добрый день", port: "Boa tarde." },
  { ru: "Думаю,  да.", port: "Acho que sim." },
  { ru: "Думаю, нет.", port: "Acho que não." },
  { ru: "Еще нет.", port: "Ainda não." },
  { ru: "Жарко.", port: "Está calor / quente." },
  { ru: "Здоровья!", port: "Saúde!" },
  {
    ru: "К сожалению, не говорю по португальски/ английски",
    port: "Infelizmente, eu não falo português / inglês.",
  },
  { ru: "Как жаль!", port: "Que pena!" },
  { ru: "Как погода?", port: "Como está o tempo?" },
  { ru: "Как тебя зовут?", port: "Como se chama?" },
  { ru: "Как ты?", port: "Como está?" },
  { ru: "Как ты?", port: "Como vai?" },
  { ru: "Как это работает?", port: "Como funciona?" },
  { ru: "Какой сегодня день?", port: "Que dia é hoje?" },
  { ru: "Какой ты национальности?", port: "Qual é a sua nacionalidade?" },
  { ru: "Какой час?", port: "Que horas são?" },
  { ru: "Конечно", port: "Com certeza / Certamente." },
  { ru: "Что случилось?", port: "O que aconteceu?" },
  { ru: "Что ты сказал?", port: "Como disse?" },
  { ru: "Что это значит?", port: "O que é que isso significa?" },
  { ru: "Это возможно….?", port: "É possível…?" },
  {
    ru: "Это мой брат/Это моя сестра",
    port: "Este é o meu irmão / Esta é a minha irmã.",
  },
  {
    ru: "Это мой муж/Это моя жена.",
    port: "Este é o meu marido / Esta é a minha mulher.",
  },
  { ru: "Это мой отец", port: "Este é o meu pai." },
  { ru: "Это мой ребенок.", port: "Este é o meu bebé." },
  {
    ru: "Это моя дочь/Это мой сын.",
    port: "Esta é a minha filha / Este é o meu filho.",
  },
  { ru: "Это моя мама", port: "" },
  { ru: "Я боюсь.", port: "Estou assustado." },
  { ru: "Конечно!", port: "Claro!" },
  { ru: "Кто может помочь мне?", port: "Quem poderia ajudar-me?" },
  { ru: "Кто ты по професии?", port: "Qual é a sua profissão?" },
  { ru: "Где ….?", port: "Onde está…?" },
  {
    ru: "Где комната/комната номер X?",
    port: "Onde fica a sala / o quarto número X?",
  },
  { ru: "Где могу купить ….?", port: "Onde posso comprar...?" },
  { ru: "Где могу найти…?", port: "Onde posso encontrar...?" },
  { ru: "Где находится метро?", port: "Onde fica o metro?" },
  { ru: "Где находится туалет?", port: "Onde fica a casa de banho?" },
  { ru: "Где я могу принять душ?", port: "Onde posso tomar um banho?" },
  { ru: "Я голоден.", port: "Estou com fome." },
  {
    ru: "Я забыл ключ от машины/комнаты/дома.",
    port: "Esqueci-me da chave do carro / do quarto / de casa.",
  },
  {
    ru: "Я забыл свой кошелек/деньги/чеки/кредитную карту.",
    port: "Esqueci-me da carteira / do dinheiro / dos cheques / do cartão de crédito.",
  },
  {
    ru: "Я не говорю хорошо по португальски.",
    port: "Não falo muito bem português.",
  },
  {
    ru: "Я не могу  найти... Можно ли указать мне дорогу?",
    port: "Não encontro… É possível indicar-me o caminho?",
  },
  { ru: "Я родом из... / Я из....", port: "Venho de... / Sou de...." },
  { ru: "Я счастлив.", port: "Estou feliz." },
  {
    ru: "Я холост/женат/разведен/вдовец.",
    port: "Sou solteiro(a) / casado(a) / divorciado(a) / viúvo(a).",
  },
  { ru: "Где.. /Где находится …?", port: "Onde é…? / Onde fica...?" },
  { ru: "Говорите по…?", port: "Fala…?" },
  {
    ru: "Говоришь по португальски/ английски?",
    port: "Fala português / inglês?",
  },
  { ru: "Да", port: "Sim." },
  {
    ru: "Да, говорю по португальски/ английски",
    port: "Sim, falo português / inglês.",
  },
  { ru: "Не важно.", port: "Não é importante." },
  { ru: "Не волнуйтесь", port: "Não se preocupe." },
  { ru: "Не .", port: "De nada / Não tem de quê." },
  { ru: "Не знаю", port: "Não sei." },
  { ru: "Не понимаю", port: "Não entendo / Não compreendo." },
  { ru: "Нет.", port: "Não." },
  { ru: "Очень ветренно/ хололдно", port: "Está muito vento / frio." },
  {
    ru: "Погода ухудшается/улучшается.",
    port: "O tempo está a piorar / melhorar.",
  },
  { ru: "Пожалуйста.", port: "Por favor." },
  { ru: "Поздравляю!", port: "Parabéns!" },
  { ru: "Пока", port: "Adeus." },
  {
    ru: "Помогите/Помогите мне, пожалуйста",
    port: "Ajuda! / Ajude-me, por favor!",
  },
  { ru: "Привет", port: "Olá." },
  { ru: "Привет семье!", port: "Cumprimentos à sua família!" },
  { ru: "Простите", port: "Desculpe." },
  { ru: "Сегодня хорошая погода", port: "Hoje está bom tempo." },
  { ru: "Серьезно?", port: "A sério?" },
  { ru: "Скоро вернусь", port: "Já volto / Volto já." },
  { ru: "Спасибо.", port: "Obrigado / Obrigada." },
  { ru: "Счастливого Нового года!", port: "Feliz Ano Novo!" },
  { ru: "Счастливого Рождества!", port: "Feliz Natal!" },
  { ru: "Счастливой Пасхи!", port: "Páscoa feliz!" },
  { ru: "Точно.", port: "Com certeza." },
  { ru: "Ты мне нравишся", port: "Gosto de si / de ti." },
  { ru: "Ты не прав.", port: "Você está errado." },
  { ru: "Ты прав.", port: "Você tem razão." },
  { ru: "У вас есть…?", port: "Tem...?" },
  { ru: "У меня еще нет детей", port: "Ainda não temos filhos." },
  { ru: "У меня нет денег.", port: "Não tenho dinheiro." },
  { ru: "У меня Х детей", port: "Temos X filhos." },
  { ru: "Увидимся.", port: "Até logo." },
  { ru: "Удачи.", port: "Boa sorte." },
  { ru: "Хороших выходных!", port: "Boas férias!" },
  { ru: "Хорошо, спасибо.", port: "Estou bem, obrigado / obrigada." },
  { ru: "Хочу пить.", port: "Tenho sede." },
  { ru: "До скорого!", port: "Até à vista! / Até breve!" },
  { ru: "Мне грустно.", port: "Estou triste." },
  { ru: "Мне ничего не понравилось.", port: "Não gostei nada." },
  { ru: "Мне нужно позвонить", port: "Preciso de fazer uma chamada " },
  { ru: "Мне нужно поспать.", port: "Preciso de dormir." },
  { ru: "Мне нужно принять душ.", port: "Preciso de tomar banho." },
  { ru: "Мне холодно/ Я замерз.", port: "Tenho frio." },
  { ru: "Мне это очень нравится.", port: "Gosto muito disso." },
  { ru: "Мое имя…", port: "O meu nome é..." },
  { ru: "Можете написать?", port: "Pode escrever?" },
  { ru: "Можете перевести мне это?", port: "Podia traduzir-me isto?" },
  { ru: "Можете повторить, пожалуйста?", port: "Podia repetir, por favor?" },
  { ru: "Можете помочь мне, пожалуйста?", port: "Pode ajudar-me, por favor?" },
  {
    ru: "Можете сказать мне время, пожалуйста?",
    port: "Pode dizer-me as horas, por favor?",
  },
  { ru: "Мои соболезнования!", port: "As minhas condolências!" },
  {
    ru: "Мой сын/Моя дочь голодна.",
    port: "O meu filho / A minha filha tem fome.",
  },
  { ru: "Мы хотим усыновить ребенка.", port: "Queremos adotar uma criança." },
  {
    ru: "Как долго нам придется здесь ждать?",
    port: "Quanto tempo temos de esperar aqui?",
  },
  { ru: "Вы должны подождать", port: "Tem de aguardar." },
];

export const fraz_2 = [
  {
    ru: "Я здесь в отпуске/по делам.",
    port: "Estou aqui de férias / em negócios.",
  },
  {
    ru: "Я здесь в отпуске/по делам.",
    port: "Estou aqui de férias / em negócios.",
  },
  {
    ru: "Как долго продлится пребывание?",
    port: "Qual será a duração da estadia?",
  },
  {
    ru: "Я остаюсь здесь на несколько дней/неделю/пятнадцать дней/месяц.",
    port: "Fico aqui alguns dias / uma semana / quinze dias / um mês.",
  },
  { ru: "Я еще не знаю", port: "Ainda não sei." },
  { ru: "Ваши документы, пожалуйста", port: "Os seus documentos, por favor." },
  {
    ru: "Вот / мой паспорт/наши паспорта/мое удостоверение личности/мое удостоверение гражданства/мой вид на жительство.",
    port: "Aqui está / estão... o meu passaporte / os nossos passaportes / o meu bilhete de identidade / o meu cartão de cidadão / a minha autorização de residência.",
  },
  {
    ru: "Заполните эту форму/этот целевой документ.",
    port: "Preencha este formulário / este documento de desembarque.",
  },
  {
    ru: "Хотите увидеть документы на машину?",
    port: "Quer ver os documentos do carro?",
  },
  { ru: "Я хотел посетить этот регион.", port: "Queria visitar a região." },
  {
    ru: "Я предпочитаю спокойный/беспокойный фон",
    port: "Prefiro um plano calmo / agitado.",
  },
  { ru: "Какая погода?", port: "Como é o clima?" },
  {
    ru: "Где я могу поймать такси/метро/автобус?",
    port: "Onde posso apanhar um táxi / o metro / um autocarro?",
  },
  {
    ru: "Где можно взять машину напрокат?",
    port: "Onde posso alugar um carro?",
  },
  {
    ru: "Я хотел арендовать машину на весь день.",
    port: "Queria alugar um carro para todo o dia.",
  },
  {
    ru: "Что самое интересное посетить?",
    port: "O que há de mais interessante para visitar?",
  },
  {
    ru: "Здесь есть туристический офис?",
    port: "Há um posto de turismo por aqui?",
  },
  {
    ru: "Где находится туристический офис?",
    port: "Onde fica o posto de turismo?",
  },
  {
    ru: "Есть ли здесь гид, говорящий на португальском/испанском/английском/французском языках?",
    port: "Há aqui um guia que fale português / espanhol / inglês / francês?",
  },
  {
    ru: "Мне не нужно, чтобы ты сопровождал меня, спасибо.",
    port: "Não preciso que me acompanhem, obrigado / obrigada.",
  },
  { ru: "Мне нужна/не нужна помощь.", port: "Preciso / Não preciso de ajuda." },
  {
    ru: "Можете ли вы порекомендовать мне агентство по прокату автомобилей?",
    port: "Pode indicar-me uma agência de aluguer de automóveis?",
  },
  {
    ru: "Я хотел бы арендовать автомобиль/дом на колесах/джип/мотоцикл",
    port: "Queria alugar um carro / uma caravana / um jipe / uma mota.",
  },
  {
    ru: "Извините, вы говорите по-португальски/по-английски?",
    port: "Desculpe, fala português / inglês?",
  },
  {
    ru: "Можете ли вы показать мне дорогу к… / сказать мне, где это…?",
    port: "Pode indicar-me o caminho para… / dizer-me onde fica…?",
  },
  { ru: "Это дорога ведет к…?", port: "Esta é a estrada para…?" },
  {
    ru: "Как далеко ближайший город?",
    port: "A que distância fica a localidade mais próxima?",
  },
  { ru: "Как далеко я от…?", port: "A que distância estou de…?" },
  { ru: "Где этот адрес?", port: "Onde fica esta morada?" },
  {
    ru: "Можете ли вы показать мне на карте, где я/где это…?",
    port: "Pode mostrar-me no mapa onde estou / onde fica…?",
  },
  {
    ru: "Через сколько километров ближайшая станция технического обслуживания?",
    port: "A quantos quilómetros fica a próxima estação de serviço?",
  },
  {
    ru: "Где находится ближайшая заправка?",
    port: "Onde fica o posto de gasolina mais próximo?",
  },
  { ru: "Где ближайшая мастерская?", port: "Onde é a oficina mais próxima?" },
  { ru: "Ищу мастерскую", port: "Procuro uma oficina." },
  {
    ru: "Можете ли вы отправить мне экстренную помощь/эвакуатор?",
    port: "Pode mandar-me um pronto-socorro / reboque?",
  },
  { ru: "Закончился бензин", port: "Acabou a gasolina." },
  { ru: "Можете помочь мне?", port: "Pode ajudar-me?" },
  { ru: "Он совершил ошибку на дороге.", port: "Enganou-se na estrada." },
  {
    ru: "Идите вперед/направо/налево.",
    port: "Siga em frente / à direita / à esquerda.",
  },
  { ru: "Это там/на заднем плане.", port: "É lá em baixo / ao fundo." },
  {
    ru: "Поверните направо/налево/после светофора/за угол.",
    port: "Vire à direita / à esquerda / depois dos semáforos / na esquina.",
  },
  {
    ru: "Идите до первого/второго перекрестка.",
    port: "Vá até ao primeiro / segundo cruzamento.",
  },
  { ru: "Слишком далеко идти.", port: "É muito longe para ir a pé." },
  { ru: "Где можно припарковаться?", port: "Onde posso estacionar?" },
  { ru: "Можно ли здесь припарковаться?", port: "Posso estacionar aqui?" },
  {
    ru: "Парковка бесплатная/платная?",
    port: "O parque de estacionamento é gratuito / pago?",
  },
  { ru: "Где находится вокзал?", port: "Onde fica a estação de comboios?" },
  { ru: "Я ищу билетную кассу.", port: "Procuro a bilheteira." },
  {
    ru: "Есть ли на вокзале туристический офис?",
    port: "Há algum posto de turismo na estação?",
  },
  {
    ru: "Где находится камера хранения/касса/линия X/зал ожидания/киоск (газет)?",
    port: "Onde fica o depósito da bagagem / a bilheteira / a linha X / a sala de espera / o quiosque (de jornais)?",
  },
  {
    ru: "Мне хотелось бы расписание поездов, пожалуйста.",
    port: "Queria um horário dos comboios, por favor.",
  },
  {
    ru: "Поезд тоже останавливается на… станции?",
    port: "O comboio para também na estação de…?",
  },
  {
    ru: "Необходимо ли делать бронирование?",
    port: "É preciso fazer reserva?",
  },
  {
    ru: "Во сколько отправляется (следующий) поезд в…?",
    port: "A que horas parte o (próximo) comboio para…?",
  },
  { ru: "Есть ли поезд в…?", port: "Há um comboio às…?" },
  { ru: "В какое время мы прибываем...?", port: "A que horas chegamos a…?" },
  {
    ru: "На какой причал прибывает… поезд?",
    port: "Em que cais chega o comboio de…?",
  },
  { ru: "Сколько стоит билет на…?", port: "Quanto custa um bilhete para…?" },
  { ru: "Это мой багаж.", port: "Esta é a minha bagagem." },
  { ru: "Я не могу найти свой багаж", port: "Não encontro a minha bagagem." },
  { ru: "Это место бесплатное?", port: "Este lugar está livre?" },
  { ru: "Это место свободно?", port: "Este lugar está ocupado?" },
  { ru: "Простите, могу я пройти?", port: "Com licença, posso passar?" },
  {
    ru: "Есть ли автобус до аэропорта?",
    port: "Há algum autocarro para o aeroporto?",
  },
  { ru: "Мне нужно ехать в аэропорт.", port: "Tenho de ir para o aeroporto." },
  { ru: "Я уже зарегистрировался онлайн.", port: "Já fiz o check-in online." },
  {
    ru: "Какой выход на посадку на рейс…?",
    port: "Qual é a porta de embarque para o voo…?",
  },
  { ru: "Я хочу купить билет на…", port: "Quero comprar um bilhete para…" },
  {
    ru: "Есть ли рейс на сегодня/завтра?",
    port: "Tem algum voo para hoje / amanhã?",
  },
  {
    ru: "Во сколько вылетает/прилетает самолет?",
    port: "A que horas parte / chega o avião?",
  },
  {
    ru: "Моя сумка не пришла/потерялась.",
    port: "A minha mala não apareceu / está extraviada.",
  },
  { ru: "Какой номер рейса?", port: "Qual é o número do voo?" },
  {
    ru: "Где номер выхода на посадку...?",
    port: "Onde fica a porta de embarque número…?",
  },
  {
    ru: "Самолет собирается взлететь/приземлиться.",
    port: "O avião está prestes a descolar / aterrar.",
  },
  { ru: "Мне нужно сесть на…", port: "Preciso de embarcar para…" },
  { ru: "Можем ли мы взять животных?", port: "Podemos levar animais?" },
  { ru: "Где я могу поймать такси?", port: "Onde posso apanhar um táxi?" },
  {
    ru: "Подскажите, пожалуйста, где находится информационная стойка?",
    port: "Onde fica o balcão de informações, por favor?",
  },
  {
    ru: "Я хочу выйти на следующей остановке.",
    port: "Quero sair na próxima paragem.",
  },
  {
    ru: "Сколько стоит билет на автобус/метро?",
    port: "Quanto custa o bilhete do autocarro / do metro?",
  },
  {
    ru: "Мне нужен проездной на месяц, пожалуйста.",
    port: "Queria um passe mensal, por favor.",
  },
  {
    ru: "Когда автобус/трамвай/метро отправляется в…?",
    port: "Quando parte o autocarro / elétrico / metro para…?",
  },
  {
    ru: "Вам необходимо проверить билет в стирающей машине.",
    port: "Tem de validar o bilhete na máquina obliteradora.",
  },
];
export const fraz_3 = [
  {
    ru: "Аптечку, пожалуйста.",
    port: "Uma caixa de primeiros socorros, por favor.",
  },
  {
    ru: "Ваше кровяное давление нормальное/высокое/низкое.",
    port: "A sua tensão arterial está normal / alta / baixa.",
  },
  {
    ru: "Вы можете вызвать скорую, пожалуйста?",
    port: "Pode chamar uma ambulância, por favor?",
  },
  {
    ru: "Где я могу взять этот рецепт?",
    port: "Onde posso levantar esta receita?",
  },
  {
    ru: "Есть ли поблизости поликлиника?",
    port: "Há alguma clínica aqui perto?",
  },
  { ru: "Кто-то ударил меня.", port: "Alguém me bateu." },
  { ru: "Меня сбила машина.", port: "Eu fui atropelado por um carro." },
  { ru: "Меня тошнит.", port: "Sinto-me doente." },
  { ru: "Меня укусили.", port: "Fui mordido." },
  { ru: "Меня укусило насекомое.", port: "Fui picado por um inseto." },
  {
    ru: "Мне бы хотелось срочно записаться на прием, пожалуйста.",
    port: "Queria uma consulta com urgência, por favor.",
  },
  { ru: "Мне нужен врач, срочно!", port: "Preciso de um médico, depressa!" },
  { ru: "Мне нужна скорая.", port: "Preciso de uma ambulância." },
  {
    ru: "Мне нужно больше этого лекарства.",
    port: "Preciso de mais desta medicação.",
  },
  { ru: "Мне нужно в больницу.", port: "Preciso de ir para o hospital." },
  { ru: "Мне трудно дышать.", port: "Tenho dificuldade em respirar." },
  {
    ru: "Мое сердцебиение учащается.",
    port: "O meu batimento cardíaco está acelerado.",
  },
  { ru: "Недавно мне сделали операцию.", port: "Fui operado recentemente." },
  {
    ru: "Некоторые анализы будут необходимы.",
    port: "Vão ser necessários alguns exames.",
  },
  { ru: "Нуждаться…", port: "Preciso de…" },
  {
    ru: "Рану необходимо продезинфицировать.",
    port: "É preciso desinfetar a ferida.",
  },
  { ru: "У меня болит голова/живот.", port: "Dói-me a cabeça / o estômago." },
  { ru: "У меня болит зуб.", port: "Tenho dor de dentes." },
  { ru: "У меня боль в груди.", port: "Tenho uma dor no peito." },
  {
    ru: "У меня есть медицинская страховка.",
    port: "Tenho um seguro de saúde.",
  },
  { ru: "У меня жар.", port: "Tenho febre." },
  { ru: "У меня кашель.", port: "Tenho tosse." },
  {
    ru: "У меня кожная/респираторная/кишечная инфекция.",
    port: "Tenho uma infeção cutânea / respiratória / intestinal.",
  },
  { ru: "У меня кружится голова.", port: "Sinto tonturas." },
  { ru: "У меня назначена встреча.", port: "Tenho uma consulta marcada." },
  {
    ru: "У меня никогда раньше не было такой боли.",
    port: "Nunca tive esta dor antes.",
  },
  {
    ru: "У меня часто болит голова.",
    port: "Tenho muitas vezes dores de cabeça.",
  },
  {
    ru: "Что вы можете мне посоветовать от боли...?",
    port: "O que me pode aconselhar para as dores de…?",
  },
  {
    ru: "Это инфекция/воспаление/синяк.",
    port: "É uma infeção / uma inflamação / um hematoma.",
  },
  { ru: "Это мое лекарство.", port: "Esta é a minha medicação." },
  { ru: "Я был ранен.", port: "Fui ferido." },
  { ru: "Я диабетик/диабетик.", port: "Sou diabético / diabética." },
  { ru: "Я не могу есть.", port: "Não consigo comer." },
  {
    ru: "Я плохо себя чувствую, думаю, упаду в обморок.",
    port: "Não me sinto bem, acho que vou desmaiar.",
  },
  { ru: "Я потерял сознание.", port: "Eu desmaiei." },
  {
    ru: "Я съел что-то, что причинило мне боль.",
    port: "Comi alguma coisa que me fez mal.",
  },
  { ru: "Я упал.", port: "Eu caí." },
  {
    ru: "Я хотел аспирин/снотворное.",
    port: "Queria uma aspirina / um sonífero.",
  },
  { ru: "Я хочу назначить встречу.", port: "Quero marcar uma consulta." },
];
export const fraz_4 = [
  { ru: "Где находится отель…?", port: "Onde fica o hotel…?" },
  {
    ru: "Можете ли вы порекомендовать мне отель?",
    port: "Pode recomendar-me um hotel?",
  },
  {
    ru: "Меня зовут… У вас есть бронирование на мое имя?",
    port: "Chamo-me… Têm uma reserva em meu nome?",
  },
  {
    ru: "Я забронировал номер онлайн/по электронной почте/по телефону.",
    port: "Fiz uma reserva online / por e-mail / por telefone.",
  },
  {
    ru: "Я планирую остаться всего на одну ночь/несколько дней/минимум неделю.",
    port: "Pretendo ficar só uma noite / alguns dias / pelo menos uma semana.",
  },
  {
    ru: "Какова цена на человека/ночь/неделю/за кровать и завтрак/ночь без питания/полный пансион/полупансион?",
    port: "Qual é o preço por pessoa / por noite / por semana / por dormida e pequeno-almoço / por dormida sem refeições / com pensão completa / com meia pensão?",
  },
  { ru: "Пожалуйста, распишитесь здесь.", port: "Assine aqui, por favor." },
  { ru: "В какое время обед?", port: "A que horas são as refeições?" },
  { ru: "Нет горячей/холодной воды.", port: "Não há água quente / fria " },
  {
    ru: "Дверь не закрывается/не открывается.",
    port: "A porta não fecha / não abre.",
  },
  { ru: "Выходим около Х часов.", port: "Partimos por volta de X horas." },
  {
    ru: "До какого времени разрешен выезд?",
    port: "Até que horas é permitido o checkout?",
  },
  { ru: "Как я могу заплатить?", port: "Como posso pagar?" },
  {
    ru: "Где я могу арендовать велосипед?",
    port: "Onde posso alugar uma bicicleta?",
  },
  {
    ru: "Queria arrendar uma casa / um quarto para o mês de agosto.",
    port: "Queria arrendar uma casa / um quarto para o mês de agosto.",
  },
  {
    ru: "Я хочу снять дом/квартиру на срок одну неделю/один месяц/один год.",
    port: "Quero arrendar uma casa / um apartamento por um período de uma semana / um mês / um ano.",
  },
  { ru: "Какой номер комнаты?", port: "Qual é o número do quarto?" },
  { ru: "В отеле есть бесплатный Wi-Fi?", port: "O hotel tem wi-fi gratuito?" },
  { ru: "Какой пароль от Wi-Fi?", port: "Qual é a password do wi-fi?" },
];
export const fraz_6 = [
  {
    ru: "Можете ли вы порекомендовать мне ресторан?",
    port: "Pode indicar-me um restaurante?",
  },
  {
    ru: "Где женский/мужской туалет?",
    port: "Onde fica a casa de banho das senhoras / dos homens?",
  },
  {
    ru: "Добрый вечер! Мне, пожалуйста, столик на троих.",
    port: "Boa noite! Queria uma mesa para três pessoas, por favor.",
  },
  {
    ru: "Можете принести мне меню, пожалуйста?",
    port: "Pode trazer-me a ementa, por favor?",
  },
  {
    ru: "Есть ли у вас блюдо дня/типичные блюда/блюда для детей/вегетарианские/веганские/безглютеновые блюда?",
    port: "Tem prato do dia / pratos típicos / pratos para crianças / prato vegetariano / vegan / sem glúten?",
  },
  { ru: "У меня аллергия/аллергия на", port: "Sou alérgico / alérgica a…" },
  { ru: "Каковы типичные блюда?", port: "Quais são os pratos típicos?" },
  { ru: "Я не ем свинину.", port: "Eu não como carne de porco." },
  {
    ru: "Я вегетарианец/вегетарианец/не ем мясо и рыбу.",
    port: "Sou vegetariano / vegetariana / Não como carne e peixe.",
  },
  { ru: "Я не пью алкоголь.", port: "Eu não bebo álcool." },
  {
    ru: "Я хотел посмотреть карту вин.",
    port: "Queria ver a carta de vinhos.",
  },
  { ru: "Мне, пожалуйста, аперитив.", port: "Queria um aperitivo, por favor." },
  {
    ru: "Я бы хотел попробовать… пожалуйста.",
    port: "Queria provar… por favor.",
  },
  {
    ru: "Как вы предпочитаете мясо? Хорошо прожареное/ Плохо прожареное",
    port: "Como prefere a carne? Bem passada / Mal passada.",
  },
  {
    ru: "Не могли бы вы принести еще хлеба/воды/вина?",
    port: "Poderia trazer mais pão / água / vinho?",
  },
  {
    ru: "Я хочу кофе/эспрессо/без кофеина.",
    port: "Quero um café / expresso / descafeinado.",
  },
  {
    ru: "Можете ли вы принести нам тарелку/ложку/салфетку/стакан/пепельницу, пожалуйста?",
    port: "Pode trazer-nos um prato / uma colher / um guardanapo / um copo / um cinzeiro, por favor?",
  },
  {
    ru: "Он немного соленый/горький/очень сладкий.",
    port: "Está um pouco salgado / amargo / muito doce.",
  },
  {
    ru: "Мясо переваренное/недоваренное/сырое/очень жесткое.",
    port: "A carne está passada de mais / mal passada / crua / muito dura.",
  },
  { ru: "Счет, пожалуйста", port: "A conta, por favor." },
  {
    ru: "Могу ли я оплатить кредитной картой?",
    port: "Posso pagar com cartão de crédito?",
  },
  {
    ru: "Дайте мне килограмм/полкило…, пожалуйста.",
    port: "Dê-me um quilo / meio quilo de… , por favor.",
  },
  {
    ru: "Я хотел бутылку/банку/пакет/пакет…",
    port: "Queria um frasco / uma lata / um pacote / uma embalagem de…",
  },
  {
    ru: "Сколько стоит килограмм/бутылка/единица?",
    port: "Quanto custa o quilo / a garrafa / a unidade?",
  },
];
export const fraz_5 = [
  {
    ru: "Во сколько музей открывается/закрывается?",
    port: "A que horas abre / fecha o museu?",
  },
  { ru: "Вход бесплатный", port: "Entrada livre." },
  { ru: "Где мне подписать?", port: "Onde devo assinar?" },
  {
    ru: "Где находится ближайший полицейский участок?",
    port: "Onde fica a esquadra mais próxima?",
  },
  {
    ru: "Где находится кино/театр/опера/концертный зал?",
    port: "Onde fica o cinema / o teatro / a ópera / a sala de concertos?",
  },
  { ru: "Где я могу найти…?", port: "Onde posso encontrar…?" },
  {
    ru: "Где я могу посмотреть хороший спектакль/хороший фильм/концерт/варьете?",
    port: "Onde posso ver uma boa peça de teatro / um bom filme / um concerto / um espetáculo de variedades?",
  },
  {
    ru: "Есть еще билеты на сегодняшний вечер?",
    port: "Ainda há bilhetes para hoje à noite?",
  },
  {
    ru: "Есть ли поблизости почтовое отделение?",
    port: "Há alguma estação de correios aqui perto?",
  },
  { ru: "Есть ли у вас календарь культурных мероприятий?", port: "" },
  {
    ru: "Мне нужно купить очки/солнечные очки.",
    port: "Preciso de comprar uns óculos / uns óculos de sol.",
  },
  { ru: "Могу ли я взять образец?", port: "Posso levar uma amostra?" },
  { ru: "Могу ли я заплатить здесь?", port: "Posso pagar aqui?" },
  { ru: "Можете ли вы показать мне другие?", port: "Pode mostrar-me outros?" },
  {
    ru: "Можете ли вы порекомендовать хорошее шоу на сегодняшний вечер?",
    port: "Pode recomendar-me um bom espetáculo para esta noite?",
  },
  { ru: "Можно попробовать?", port: "Posso experimentar?" },
  { ru: "Можно посмотреть то", port: "Posso ver aquilo?" },
  {
    ru: "На данный момент у нас нет того, что вам нужно.",
    port: "De momento não temos o que deseja.",
  },
  {
    ru: "Нет ли чего-нибудь дешевле/лучше/больше/меньше/в другом цвете?",
    port: "Não tem nada mais barato / melhor / maior / mais pequeno / de outra cor?",
  },
  { ru: "Они ограбили мою машину.", port: "Assaltaram-me o carro." },
  { ru: "Они украли мою машину.", port: "Roubaram-me o carro." },
  {
    ru: "Пойдем в кино/театр/клуб?",
    port: "Vamos ao cinema / ao teatro / à discoteca?",
  },
  { ru: "Сколько стоит билет?", port: "Quanto custa a entrada?" },
  { ru: "Сколько это стоит?", port: "Quanto custa isto?" },
  { ru: "Хочу купить ….", port: "Queria comprar…" },
  { ru: "Эта цена фиксированная?", port: "Este preço é fixo?" },
  {
    ru: "Я прихожу забрать письмо/заказ.",
    port: "Venho levantar uma carta / uma encomenda.",
  },
  {
    ru: "Я хотел открыть зарплатный счет/совместный счет/студенческий счет.",
    port: "Queria abrir uma conta ordenado / uma conta conjunta / uma conta estudante.",
  },
  {
    ru: "Я хочу отправить этот заказ экспресс-почтой.",
    port: "Quero enviar esta encomenda por correio expresso.",
  },
  { ru: "Я хочу подать жалобу.", port: "Quero apresentar queixa." },
  { ru: "Я хочу подвести итоги.", port: "Quero embrulhar." },
  { ru: "Я хочу увидеть карту города.", port: "Quero ver o mapa da cidade." },
];

export const teamm = [
  { name: "Основные фразы", list: fraz_1 },
  { name: "Путешествия и транспорт", list: fraz_2 },
  { name: "Здоровье", list: fraz_3 },
  { name: "Отель", list: fraz_4 },
  { name: "Покупки и сервис", list: fraz_5 },
  { name: "Ресторан", list: fraz_6 },
];
